var loadMatchingVersion = require('./loadMatchingVersion');

loadMatchingVersion();



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0